import { Component, HostBinding, Inject } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface Choice {
  color?: ThemePalette;
  label: string;
  testId?: string;
  value: string;
  variant?: 'raised' | 'stroked' | 'flat';
}

export interface FwChoiceDialogData {
  alignActions?: 'start' | 'center' | 'end';
  choices: Choice[];
  closeValue?: string;
  content: string;
  title?: string;
}

/**
 * @deprecated Legacy Vision: Please upgrade to the newer FwDialogComponent
 */
@Component({
  selector: 'fw-legacy-dialog-choice-dialog',
  template: `
      <h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
      <button *ngIf="showCloseButton" test-id="dialog-close-corner" mat-icon-button
              [mat-dialog-close]="closeValue" [class]="{'mat-dialog-close-button': true, 'no-title': !title}">
          <mat-icon>close</mat-icon>
      </button>
      <div mat-dialog-content>{{ content }}</div>
      <div mat-dialog-actions [align]="alignActions">
          <ng-container *ngFor="let choice of choices" [ngSwitch]="choice.variant">
              <button *ngSwitchCase="'raised'" mat-raised-button [color]="choice.color"
                      [attr.test-id]="getTestId(choice)"
                      [mat-dialog-close]="choice.value">{{ choice.label }}
              </button>
              <button *ngSwitchCase="'stroked'" mat-stroked-button [color]="choice.color"
                      [attr.test-id]="getTestId(choice)"
                      [mat-dialog-close]="choice.value">{{ choice.label }}
              </button>
              <button *ngSwitchCase="'flat'" mat-flat-button [color]="choice.color" [attr.test-id]="getTestId(choice)"
                      [mat-dialog-close]="choice.value">{{ choice.label }}
              </button>
              <ng-container *ngSwitchDefault>
                  <button *ngIf="choice.color" mat-flat-button [color]="choice.color" [attr.test-id]="getTestId(choice)"
                          [mat-dialog-close]="choice.value">{{ choice.label }}
                  </button>
                  <button *ngIf="!choice.color" mat-stroked-button [attr.test-id]="getTestId(choice)"
                          [mat-dialog-close]="choice.value">{{ choice.label }}
                  </button>
              </ng-container>
          </ng-container>
      </div>
  `,
})

export class FwLegacyChoiceDialogComponent {
  @HostBinding('attr.class') class = 'mat-dialog-component';
  @HostBinding('attr.test-id') 'test-id' = 'choice-dialog';
  readonly alignActions: 'start' | 'center' | 'end' = this.data.alignActions || 'start';
  readonly choices = this.data.choices;
  readonly closeValue = this.data.closeValue;
  readonly content = this.data.content;
  readonly title = this.data.title;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: FwChoiceDialogData,
  ) {
  }

  get showCloseButton(): boolean {
    return 'closeValue' in this.data;
  }

  getTestId(choice: Choice): string {
    return choice.testId || `${ String(choice.label ?? choice.value).toLowerCase() }-button`;
  }
}
